import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ToastService } from '@teorema/patron';
import { CoreConfig } from 'src/app/models/core-config.model';
import { constants, utils } from 'src/app/shared';
import { AuthService } from '../auth.service';
import { FirebaseService } from '../firebase.service';
import { FirebaseErrors } from './firebase-errors';

@Component({
  templateUrl: './reset-password.component.html',
  standalone: false,
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  config: CoreConfig;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private firebaseService: FirebaseService,
    private toastService: ToastService,
    private titleService: Title
  ) {
    this.formGroup = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.config = this.authService.getCoreConfig();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.titleService.setTitle(`Recuperar senha | ${this.config.panelTitle}`);
    }, 100);

    const user: any = utils.getUser();
    if (user?.email) {
      this.f['email'].setValue(user.email);
    }
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(this.config.panelTitle!);
  }

  formGroup!: FormGroup;
  submitted: boolean = false;
  loading: boolean = false;

  get f() {
    return this.formGroup.controls;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formGroup.invalid) {
      return;
    }

    this.loading = true;
    const email = this.f['email'].value;
    await this.firebaseService
      .sendPasswordResetEmail(email)
      .then(() => {
        localStorage.setItem(constants.patronChangePasswordEmail, email);
        this.toastService.show({
          color: 'info',
          message: `Enviamos um link para redefinição de senha no e-mail ${email}`,
        });
      })
      .catch((error: any) => {
        if (error.code === 'auth/user-not-found') {
          this.authService.existUserByEmail(email).then((response: any) => {
            if (response.status === 'OK') {
              const timestampSeconds = Math.floor(Date.now() / 1000);
              this.firebaseService
                .firebaseCreateUser(email, `AAABBC${timestampSeconds}`)
                .then(() => {
                  this.onSubmit();
                });
            } else {
              this.toastService.show({
                color: 'info',
                message: FirebaseErrors.Parse(error.code),
              });
            }
          });
        }
      });

    this.loading = false;
  }
}
